import { useTranslation } from 'react-i18next';
import { useSchedulerSidebar } from '@contexts/scheduler/sidebar';
import { RadioGroup, RadioGroupItem } from '@components/ui/radio';
import { Label } from '@components/ui/form/label';
import { SchedulerSidebarCrewChangeScope } from '@contexts/scheduler/sidebar/types';
import { useState } from 'react';
import { cn } from '@utils/cn';
import { Button } from '@components/ui/button';
import { SvgConsumer } from '@components/icons/svgConsumer';

export const SchedulerSidebarChanges = () => {
  const {
    crewChangeScope,
    disabled,
    setState: setSchedulerSidebarState,
    relatedMultischedules,
  } = useSchedulerSidebar();

  const { t } = useTranslation('app', { keyPrefix: 'schedule.changes' });

  const [expanded, setExpanded] = useState(true);

  if (!relatedMultischedules || !Object.keys(relatedMultischedules).length) return null;

  const renderDrawerContent = () => {
    return (
      <div className="flex flex-col gap-1">
        <p className="text-xs font-normal text-neutral-500">{t('message')}</p>
        <RadioGroup
          value={crewChangeScope}
          onValueChange={(v) => {
            setSchedulerSidebarState((prev) => ({
              ...prev,
              crewChangeScope: v as SchedulerSidebarCrewChangeScope,
            }));
            setExpanded(false);
          }}
          className="flex flex-col gap-2 p-2">
          <div className="flex items-center gap-2">
            <RadioGroupItem value="currentOnly" id="crew-current-only" />
            <Label htmlFor="crew-current-only" className="cursor-pointer text-xs font-semibold">
              {t('options.currentOnly')}
            </Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="currentAndFuture" id="crew-current-and-future" />
            <Label
              htmlFor="crew-current-and-future"
              className="cursor-pointer text-xs font-semibold">
              {t('options.currentAndFuture')}
            </Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="all" id="crew-all" />
            <Label htmlFor="crew-all" className="cursor-pointer text-xs font-semibold">
              {t('options.all')}
            </Label>
          </div>
        </RadioGroup>
      </div>
    );
  };

  return (
    <div
      className={cn(
        'flex flex-col gap-2 border-t p-2',
        disabled && 'opacity-50 bg-neutral-50 pointer-events-none',
      )}>
      <div
        className="flex items-center gap-2 justify-between cursor-pointer"
        onClick={() => {
          setExpanded(!expanded);
        }}>
        <div className="flex items-center gap-2 justify-between w-full">
          <strong className="font-semibold text-xs">{t('title')}</strong>
          {!expanded && (
            <span className="text-xs font-semibold text-primary-500">
              {t(`options.${crewChangeScope}`)}
            </span>
          )}
        </div>
        <Button
          variant="ghost"
          className="h-fit gap-2 px-0 py-2 text-neutral-400 hover:bg-transparent hover:text-neutral-700"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}>
          <SvgConsumer id="expand" className={cn('shrink-0 text-xs', !expanded && 'rotate-180')} />
        </Button>
      </div>
      {expanded ? renderDrawerContent() : null}
    </div>
  );
};
